import { render, staticRenderFns } from "./JsonCodeDiff.vue?vue&type=template&id=639c84d9&scoped=true"
import script from "./JsonCodeDiff.vue?vue&type=script&lang=js"
export * from "./JsonCodeDiff.vue?vue&type=script&lang=js"
import style0 from "./JsonCodeDiff.vue?vue&type=style&index=0&id=639c84d9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "639c84d9",
  null
  
)

export default component.exports